import type { InputType } from 'config'
import { LienTypeOption } from 'pages/LoanStructure/interfaces'

export const otherMortgageLoansColumnKeys = [
  'concurrentClosing',
  'creditorName',
  'lienPriority',
  'monthlyPayment',
  'balanceAtClosing',
  'helocCreditLimit',
] as const

export const otherMortgageLoansColumnHeaders: Record<string, string> = {
  concurrentClosing: 'Type',
  creditorName: 'Creditor Name',
  lienPriority: 'Lien Position',
  monthlyPayment: 'Payment',
  balanceAtClosing: 'Loan / Draw Amount',
  helocCreditLimit: 'Credit Limit',
}

const creditorTypeOptions = [
  'Community Non Profit',
  'Employer',
  'Federal Agency',
  'Lender',
  'Local Agency',
  'Non Profit Instrumentality Of Government',
  'Parent',
  'Property Seller',
  'Relative',
  'Religious Non Profit',
  'State Agency',
  'Unmarried Partner',
  'Unrelated Friend',
  'Institutional (obsolete)',
  'Non Parent Relative (obsolete)',
]

export const otherMortgageLoansInputs: Record<string, InputType> = {
  lienPriority: {
    title: 'Lien Priority',
    inputType: 'select',
    hasDefaultOption: true,
    options: LienTypeOption as any,
    value: '',
    error: '',
    required: true,
  },
  concurrentClosing: {
    title: 'Concurrent Closing',
    inputType: 'checkbox',
    value: false,
    error: '',
  },
  heloc: {
    title: 'HELOC',
    inputType: 'checkbox',
    value: false,
    error: '',
  },
  creditorName: {
    title: 'Creditor Name',
    inputType: 'text',
    value: '',
    error: '',
  },
  creditorType: {
    title: 'Creditor Type',
    inputType: 'select',
    hasDefaultOption: true,
    options: creditorTypeOptions,
    value: '',
    error: '',
  },
  isCreditorNaturalPerson: {
    title: 'Creditor is a Natural Person',
    inputType: 'checkbox',
    value: false,
    error: '',
  },
  balanceAtClosing: {
    title: 'Balance at Closing / Amount to be Drawn',
    inputType: 'text',
    type: 'thousandSep',
    prefix: '$',
    value: '',
    error: '',
  },
  maturityPeriod: {
    title: 'Maturity Period (Term) in months',
    inputType: 'text',
    type: 'thousandSepNoDecimal',
    value: '',
    error: '',
  },
  interestRate: {
    title: 'Interest Rate',
    inputType: 'text',
    type: 'thousandSep',
    prefix: '%',
    value: '',
    error: '',
  },
  monthlyPayment: {
    title: 'Monthly Payment',
    inputType: 'text',
    type: 'thousandSep',
    prefix: '$',
    value: '',
    error: '',
  },
  helocCreditLimit: {
    title: 'HELOC Credit Limit',
    inputType: 'text',
    type: 'thousandSep',
    prefix: '$',
    value: '',
    error: '',
  },
  loanAffordable: {
    title: "'Loan Affordable' Loan",
    inputType: 'select',
    hasDefaultOption: true,
    options: ['Yes', 'No'],
    value: '',
    error: '',
  },
  mortgageType: {
    title: 'Mortgage Type',
    inputType: 'select',
    hasDefaultOption: true,
    options: ['VA', 'FHA', 'Conventional', 'RHS', 'Other', 'HELOC', 'State Agency', 'Local Agency'],
    value: '',
    error: '',
  },
}
